import ShippingIcon from "@assets/images/shipping-icon.svg";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid
} from "@material-ui/core";
import DataTable from "@saleor/changeOrder/components/DataSortTable";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import uniq from "lodash/uniq";
import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

interface addressInterface {
  addressText: string;
  displayText: string;
  partnerFunction: string;
  partnerNo: string;
  partnerName: string;
  address?: string;
}

export interface ModalAddressProps {
  onClose: () => void;
  visible: boolean;
  address: addressInterface[];
  handleApplyAddress: (value: string) => void;
  initAddress: string;
}

export const useStyles = makeStyles(
  theme => ({
    dialogTitle: {
      textAlign: "left",
      padding: "0",
      display: "flex"
    },
    dialogTitleWrap: {
      height: "40px",
      display: " flex",
      alignItems: "center",
      lineHeight: "normal",
      marginBottom: "24px",
      marginTop: "0px"
    },
    mainTitle: {
      fontSize: "2rem",
      color: theme.palette.grey[900],
      fontWeight: 700
    },
    subTitle: {
      color: theme.palette.info.main,
      fontWeight: 400,
      fontSize: "1.6rem"
    },
    closeDialog: {
      cursor: "pointer"
    },
    root: {
      "& .MuiPaper-root": {
        maxWidth: 600,
        width: "100%",
        borderRadius: 12,
        padding: " 24px 32px"
      },
      "& .MuiDialogTitle-root": {
        padding: "0",
        display: "flex"
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        paddingBottom: 24
      },
      "& .MuiFormControlLabel-label": {
        fontSize: "1.4rem",
        lineHeight: "22px",
        color: theme.palette.grey[900]
      },
      "& .MuiRadio-root svg": {
        width: 18,
        height: 18
      }
    },
    detailTitle: {
      fontWeight: "bold",
      marginBottom: 10,
      "& .normalText": {
        fontWeight: "normal"
      }
    },
    dialogContent: {
      maxHeight: "calc(100% - 64px)",
      overflow: "auto",
      padding: "0 !important",
      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      }
    },
    labelRadio: {
      marginBottom: "2rem"
    },
    rowlength: {
      color: "#009FB8",
      fontFamily: "SCG",
      fontSize: "20px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "26px"
    },
    formControlLabel: {
      marginBottom: "2.5rem"
    },
    buttonAction: {
      width: "50%",
      height: 48
    },
    nameHead: {
      marginTop: 0,
      marginLeft: "12px",
      display: "flex !important",
      h2: {
        display: "flex !important"
      }
    },
    buttonWrap: {
      padding: "0px",
      marginTop: "24px"
    }
  }),
  { name: "ModalAddress" }
);

const ModalAddress: React.FC<ModalAddressProps> = props => {
  const { visible, onClose, address, handleApplyAddress, initAddress } = props;
  const [shipping, setShipping] = useState<string>();
  const [selectedRow, setSelectedRow] = useState(
    initAddress?.split("-")[0]?.trim()
  );
  const [listAddress, setListAddress] = useState<addressInterface[]>([]);
  const classes = useStyles();
  const intl = useIntl();

  const getFormattedAddress = address => {
    const parts = address?.split("\n");
    return parts.length > 1 ? parts[1].trim() : address;
  };

  const rows = uniq(listAddress).map(shippingAddress => ({
    ShiptoCode: shippingAddress.partnerNo,
    shippingAddress: (
      <>
        <strong>{shippingAddress.partnerName}</strong>
        <br />
        {getFormattedAddress(shippingAddress.address)}
      </>
    )
  }));

  const columns = [
    { field: "ShiptoCode", headerName: "Ship-to Code", width: 90 },
    { field: "shippingAddress", headerName: "Name", width: 200 }
  ];

  const convertText = e => {
    if (!e?.addressText && e?.displayText) {
      return {
        address: `${e?.displayText}`,
        partnerNo: e?.partnerNo,
        partnerName: e?.partnerName
      };
    }
    if (!e?.addressText && !e?.displayText) {
      return e;
    }

    return {
      address: `${e?.addressText}`,
      partnerNo: e?.partnerNo,
      partnerName: e?.partnerName
    };
  };
  useEffect(() => {
    if (visible) {
      setListAddress(address.map(e => convertText(e)));
    }
  }, [visible, address, initAddress]);

  const clearSelectVariant = () => {
    onClose();
    setShipping("");
  };

  const dataRenderModal = {
    iconHead: ShippingIcon,
    nameHead: intl.formatMessage({
      defaultMessage: "Ship-to Party"
    }),
    label: intl.formatMessage({
      defaultMessage: "ข้อมูลสถานที่จัดส่ง"
    })
  };
  const handleSubmit = () => {
    handleApplyAddress(shipping);
    clearSelectVariant();
  };
  const handleRowSelection = (selectedRowIndex: string) => {
    const selectedItem = listAddress.find(
      list => list.partnerNo === selectedRowIndex
    );
    if (selectedItem) {
      const a = selectedItem;
      setShipping(a.address);
    }
  };

  return (
    <Dialog
      data-testid="modalAddress"
      open={visible}
      onClose={onClose}
      className={classes.root}
    >
      <DialogTitle className={classes.dialogTitle}>
        <div className={classes.dialogTitleWrap}>
          <img src={dataRenderModal?.iconHead} alt="shipping-icon" />
          <MyTypography variant={"h6"} className={classes.nameHead}>
            {dataRenderModal?.nameHead}&nbsp;
            <span className={classes.rowlength}>({rows.length})</span>
          </MyTypography>
        </div>
      </DialogTitle>
      <DialogContent dividers={false} className={classes.dialogContent}>
        <Grid container>
          <Grid item xs={12} md={12}>
            <DataTable
              selectedRow={selectedRow}
              setSelectedRow={setSelectedRow}
              headCells={columns}
              rows={rows}
              onRowSelect={handleRowSelection}
              sortField="ShiptoCode"
              boldFields={["ShiptoCode", "partnerName"]}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className={classes.buttonWrap}>
        <Button
          id="cancelButton"
          data-testid="cancelButton"
          variant={"outlined"}
          color={"secondary"}
          className={classes.buttonAction}
          onClick={clearSelectVariant}
        >
          <FormattedMessage defaultMessage={"ยกเลิก"} />
        </Button>
        <Button
          id="submitButton"
          data-testid="submitButton"
          variant={"contained"}
          color={"secondary"}
          className={classes.buttonAction}
          disabled={!shipping}
          onClick={handleSubmit}
        >
          <FormattedMessage defaultMessage={"ตกลง"} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ModalAddress.displayName = "ModalAddress";
export default ModalAddress;
